import { useDebugValue } from 'react';
import * as React from 'react';
import { UpdatableContext } from './UpdatableContext';
import AuthUser from 'Core/Models/AuthUser';

const data = undefined;
const Update = () => {};

const AuthContext = React.createContext<UpdatableContext<AuthUser>>({ data, Update });

export default AuthContext;
